module.exports = __webpack_public_path__ + "static/media/tavuk-dunyasi-biköri.d9b17fe2.jpg";